import { BLOCKS } from '@contentful/rich-text-types'
import type { PatchPageStructure } from '../types'
import { ComponentCtaButtonColor, ComponentCtaButtonType, TypeComponentCtaButton, TypePage } from '../../types'
import { isTypeComponentCtaButton } from '../../types/content-types'

const patchSignUpProductRecommendationCta = (cta: TypeComponentCtaButton): TypeComponentCtaButton => {
  if (cta.fields.type !== ComponentCtaButtonType.SignUpProductRecommendation) {
    return cta
  }

  return {
    ...cta,
    fields: {
      ...cta.fields,
      color: ComponentCtaButtonColor.UnstyledButton,
      ctaText: {
        data: {},
        content: [
          {
            data: {},
            content: [
              {
                data: {},
                marks: [
                  {
                    type: 'bold',
                  },
                ],
                value: 'Sign up',
                nodeType: 'text',
              },
            ],
            nodeType: BLOCKS.PARAGRAPH,
          },
        ],
        nodeType: BLOCKS.DOCUMENT,
      },
    },
  }
}

const patchPageStructure: PatchPageStructure = (
  pageStructure,
  experimentService,
  _userService,
  _browserService,
  _facadeService,
  _pageSlug
) => {
  const globalNavAnonymousTrialUphookAssignment = experimentService.getGlobalNavAnonymousTrialUphookAssignment()

  if (globalNavAnonymousTrialUphookAssignment === 'cleaner_global_nav_w_free_trial_uphook') {
    const patchedStickyCtas = pageStructure.fields?.header?.fields?.stickyCtas?.map((cta) =>
      isTypeComponentCtaButton(cta) ? patchSignUpProductRecommendationCta(cta) : cta
    )

    return {
      ...pageStructure,
      fields: {
        ...pageStructure.fields,
        header: {
          ...(pageStructure.fields?.header || {}),
          fields: {
            ...(pageStructure.fields?.header?.fields || {}),
            stickyCtas: patchedStickyCtas,
          },
        },
      },
    } as TypePage
  }

  return pageStructure
}

export const AnonymousFreeTrialExperiment = {
  patchPageStructure,
}
